function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { secondaryColors } from '../colors';
var commonButtonStyles = {
  padding: '0 16px'
};

var inputPlaceholderStyles = function inputPlaceholderStyles(theme) {
  return {
    opacity: 1,
    color: theme.palette.greyTransparent[50]
  };
};

var inputDisabledPlaceholderStyles = function inputDisabledPlaceholderStyles(theme) {
  return {
    opacity: 1,
    color: theme.palette.greyTransparent[30]
  };
};

var checkboxAndRadioStyles = function checkboxAndRadioStyles(theme) {
  return {
    root: {
      margin: '2px 3px',
      padding: 6,
      color: theme.palette.greyTransparent[50]
    },
    colorPrimary: {
      '&:hover': {
        backgroundColor: theme.palette.greyTransparent[5]
      },
      '&:active': {
        backgroundColor: theme.palette.greyTransparent[8]
      },
      '&$checked': {
        '&:hover': {
          backgroundColor: theme.palette.greyTransparent[5]
        },
        '&:active': {
          backgroundColor: theme.palette.greyTransparent[8]
        }
      },
      '&$disabled': {
        color: theme.palette.greyTransparent[20]
      }
    }
  };
};

export default (function (theme) {
  var palette = theme.palette,
      typography = theme.typography,
      transitions = theme.transitions;
  return {
    MuiLink: {
      root: {
        '&:active': {
          color: secondaryColors.navy
        }
      }
    },
    MuiButton: {
      root: _objectSpread({
        borderRadius: 2,
        letterSpacing: '1px',
        transition: transitions.create(['background-color', 'border'], {
          duration: transitions.duration.shortest
        })
      }, commonButtonStyles),
      label: {
        lineHeight: '36px',
        letterSpacing: '1px'
      },
      text: _objectSpread({}, commonButtonStyles),
      textPrimary: {
        '&:hover, &$focusVisible': {
          color: palette.primary.dark,
          backgroundColor: palette.greyTransparent[5]
        },
        '&$disabled $label': {
          color: palette.primary.light
        },
        '&:active': {
          color: palette.primary.dark,
          backgroundColor: palette.greyTransparent[10]
        }
      },
      contained: {
        boxShadow: null,
        '&$focusVisible': {
          boxShadow: null
        },
        '&:hover': {
          boxShadow: null
        },
        '&:active': {
          boxShadow: null
        }
      },
      containedPrimary: {
        '&$focusVisible': {
          backgroundColor: palette.primary.dark
        },
        '&:active': {
          backgroundColor: secondaryColors.navy
        },
        '&$disabled': {
          backgroundColor: palette.primary.light
        },
        '&$disabled $label': {
          color: palette.grey[0]
        }
      },
      outlined: _objectSpread({}, commonButtonStyles, {
        '& $label': {
          transition: transitions.create(['color'], {
            duration: transitions.duration.shortest
          })
        }
      }),
      outlinedPrimary: {
        border: "1px solid ".concat(palette.primary.main),
        '&:hover, &$focusVisible': {
          backgroundColor: palette.primary.dark,
          border: "1px solid ".concat(palette.primary.dark)
        },
        '&:hover $label, &$focusVisible $label': {
          color: palette.common.white
        },
        '&:active': {
          backgroundColor: secondaryColors.navy,
          border: "1px solid ".concat(palette.primary.dark),
          color: palette.common.white
        },
        '&$disabled': {
          border: "1px solid ".concat(palette.primary.light)
        },
        '&$disabled $label': {
          color: palette.primary.light
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: '6px',
        color: palette.greyTransparent[60],
        // NOTE: $focusVisible was not working for this component.
        '&:hover, &.Mui-focusVisible': {
          backgroundColor: palette.greyTransparent[5]
        },
        '&:active': {
          backgroundColor: palette.greyTransparent[10]
        },
        '&$disabled': {
          color: palette.greyTransparent[30]
        }
      }
    },
    MuiFilledInput: {
      root: {
        borderRadius: '2px',
        borderTopLeftRadius: null,
        borderTopRightRadius: null,
        overflow: 'hidden',
        backgroundColor: palette.greyTransparent[4],
        '&:hover:not($disabled), &$focused': {
          backgroundColor: palette.greyTransparent[8]
        },
        '&$disabled': {
          backgroundColor: palette.greyTransparent[4],
          color: palette.greyTransparent[30]
        }
      },
      input: {
        padding: '0 16px',
        '&::-webkit-input-placeholder': inputPlaceholderStyles(theme),
        '&::-moz-placeholder': inputPlaceholderStyles(theme),
        // Firefox 19+
        '&:-ms-input-placeholder': inputPlaceholderStyles(theme),
        // IE 11
        '&::-ms-input-placeholder': inputPlaceholderStyles(theme),
        // Edge
        '&$disabled::-webkit-input-placeholder': inputDisabledPlaceholderStyles(theme),
        '&$disabled::-moz-placeholder': inputDisabledPlaceholderStyles(theme),
        // Firefox 19+
        '&$disabled:-ms-input-placeholder': inputDisabledPlaceholderStyles(theme),
        // IE 11
        '&$disabled::-ms-input-placeholder': inputDisabledPlaceholderStyles(theme) // Edge

      },
      underline: {
        '&:before, &:hover:before': {
          borderBottom: "1px solid ".concat(palette.greyTransparent[30])
        },
        '&$disabled:before, &$disabled:hover:before': {
          borderBottom: 'none',
          borderBottomStyle: 'none',
          border: 'none'
        },
        '&$disabled:after': {
          border: 'none'
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: palette.text.primary,
        '&$disabled': {
          color: palette.greyTransparent[30]
        }
      }
    },
    MuiFormLabel: {
      root: _objectSpread({}, typography.label, {
        color: palette.text.primary,
        lineHeight: typography.pxToRem(24),
        marginBottom: 6,
        '&$focused': {
          color: palette.text.primary
        },
        '&$disabled': {
          color: palette.greyTransparent[30]
        }
      })
    },
    MuiInputBase: {
      root: {
        fontSize: typography.pxToRem(15),
        height: typography.pxToRem(48)
      },
      input: {
        'label[data-shrink=false] + $formControl &': null,
        boxSizing: 'content-box !important',
        // HACK for Lego. It uses `input[type="text"]`, which is more specific.
        height: null,
        lineHeight: typography.pxToRem(48)
      }
    },
    MuiInputLabel: {
      root: {
        display: null,
        transformOrigin: null
      },
      formControl: {
        top: null,
        left: null,
        position: null,
        transform: null
      },
      filled: {
        zIndex: null,
        transform: null,
        pointerEvents: null
      }
    },
    MuiInputAdornment: {
      filled: {
        color: palette.greyTransparent[50],
        '&$positionStart:not($hiddenLabel)': {
          marginTop: null
        },
        '&$positionStart p, &$positionEnd p, &$positionStart button, &$positionEnd button': {
          color: palette.greyTransparent[50]
        },
        '& .MuiCircularProgress-root': {
          width: '24px !important',
          height: '24px !important'
        }
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: typography.pxToRem(13),
        color: palette.grey[70]
      },
      contained: {
        margin: '10px 0 0',
        '&$disabled': {
          color: palette.greyTransparent[30]
        }
      }
    },
    MuiCheckbox: _objectSpread({}, checkboxAndRadioStyles(theme)),
    MuiRadio: _objectSpread({}, checkboxAndRadioStyles(theme)),
    MuiBackdrop: {
      root: {
        backgroundColor: palette.greyTransparent[10]
      }
    },
    MuiDialog: {
      root: {},
      paper: {
        boxShadow: "0 10px 20px -5px ".concat(palette.greyTransparent[50])
      }
    },
    MuiDialogContentText: {
      root: {
        color: palette.greyTransparent[100]
      }
    },
    MuiTabs: {
      root: {
        color: palette.greyTransparent[100],
        backgroundColor: palette.common.white,
        minHeight: 56,
        position: 'relative'
      },
      indicator: {
        height: 3
      },
      scroller: {
        zIndex: 1
      },
      scrollButtons: {
        height: 56,
        position: 'absolute',
        top: 0,
        left: 0,
        backgroundColor: 'inherit',
        display: 'none',
        zIndex: 2,
        // Undo above styles for right scroll button
        '& ~ .MuiTabs-scrollButtons': {
          left: 'auto',
          right: 0
        },
        // This class is added when the scroll button is made visible
        '&.MuiButtonBase-root': {
          display: 'inline-flex'
        }
      }
    },
    MuiTab: {
      root: _defineProperty({
        minWidth: null,
        maxWidth: null,
        minHeight: 56,
        padding: '0 24px',
        transition: transitions.create(['background-color', 'color'], {
          duration: transitions.duration.shortest
        })
      }, theme.breakpoints.up('sm'), null),
      textColorPrimary: {
        color: palette.greyTransparent[50],
        '&:hover:not($selected), &:focus:not($selected)': {
          backgroundColor: palette.greyTransparent[4],
          transition: transitions.create(['background-color', 'color'], {
            duration: 20
          })
        },
        '&:active:not($selected)': {
          backgroundColor: palette.greyTransparent[8]
        },
        '&$selected': {
          color: palette.greyTransparent[100],
          pointerEvents: 'none'
        }
      }
    },
    MuiTypography: {
      // TODO: Remove these once we get rid of Lego
      colorPrimary: {
        '&:visited': {
          color: palette.primary.main
        }
      },
      colorSecondary: {
        '&:visited': {
          color: palette.secondary.main
        }
      },
      colorError: {
        '&:visited': {
          color: palette.error.main
        }
      },
      colorTextPrimary: {
        '&:visited': {
          color: palette.text.primary
        }
      },
      colorTextSecondary: {
        '&:visited': {
          color: palette.text.secondary
        }
      }
    },
    MuiSnackbarContent: {
      root: _objectSpread({}, typography.body1)
    },
    MuiCircularProgress: {
      colorSecondary: {
        color: palette.common.white
      }
    },
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: '#dfd8ff'
      }
    }
  };
});